import { useCallback, useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { createPageRecovery } from "@utils/pageRecovery";

export function usePageRecovery(autoRetry = true) {
  const { asPath, locales } = useRouter();
  const recovery = useRef(null);
  const [canRetry, setCanRetry] = useState(true);

  useEffect(() => {
    const current = createPageRecovery(window, document, locales, autoRetry);
    recovery.current = current;
    setCanRetry(current.canRetry);
    return () => {
      current.stop();
      recovery.current = null;
    };
  }, [asPath, locales, autoRetry]);

  const retry = useCallback(() => recovery.current?.retry(), []);
  return { retry, canRetry };
}
